import { useCount, useFilter } from "@/global-state/global.state";
import { t } from "@/helper/helper";
import React, { FormEvent, FormEventHandler, useEffect, useState } from "react";
import { useRanger } from "react-ranger";

interface Props {
  locale: string;
}

const RangeSlider = ({ locale }: Props) => {
  const { count, destroyCount } = useCount();
  const { setFilter } = useFilter()
  const [value1, setValue1] = useState<number>(0);
  const [value2, setValue2] = useState<number>(7500);
  const [values, setValues] = useState<number[]>([value1, value2]);

  useEffect(() => {
    if (value1 === 0 && value2 === 7500) {
      setValues([value1, value2]);
      return;
    }

    setValues([value1, value2]);

  }, [value1, value2]);

  const { getTrackProps, handles } = useRanger({
    min: 0,
    max: 7500,
    stepSize: 1,
    values,
    onDrag: setValues,
  });

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setFilter({
      price: `${values[0]}-${values[1]}`
    })
  };

  return (
    <div className="range-slider">
      <div>
        <div
          className="range"
          {...getTrackProps({
            style: {
              height: "4px",
              width: "auto",
              background: "#FFDA93",
            },
          })}
        >
          {handles.map(({ getHandleProps }, index) => (
            <button
              {...getHandleProps({
                style: {
                  width: "16px",
                  height: "16px",
                  outline: "none",
                  borderRadius: "100%",
                  background: "#FFDA93",
                  border: "none",
                },
              })}
              key={index.toString() + "sliderMobile"}
            />
          ))}
        </div>
        <div className="input-container">
          <input
            type="number"
            value={values[0]}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setValue1(Number(e.target.value));
              count !== 0 && destroyCount();
            }}
          />
          <input
            type="number"
            value={values[1]}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setValue2(Number(e.target.value));
              count !== 0 && destroyCount();
            }}
          />
        </div>
        <button className="submit-btn" onClick={handleSubmit} type="button">
          {t("search", locale)}
        </button>
      </div>
    </div>
  );
};

export default RangeSlider;
